// extracted by mini-css-extract-plugin
export default {"circle":"Loader_circle__dD0xD","spin":"Loader_spin__ERuEo"};